import React from "react";
import type { CredentialListItem, MainAppPageProps } from "../types";
import { CredentialsListPage } from "./CredentialsListPage";

type CredentialsRosterPageProps = Pick<MainAppPageProps, "routes"> & {
  credentials?: CredentialListItem[];
};

export const CredentialsRosterPage: React.FC<CredentialsRosterPageProps> = ({
  routes,
  credentials = [],
}) => (
  <CredentialsListPage
    routes={routes}
    credentials={credentials}
    showTeamColumns
  />
);
